import { render } from "./BeneficiaryModal.vue?vue&type=template&id=c05633e4&scoped=true"
import script from "./BeneficiaryModal.vue?vue&type=script&lang=js"
export * from "./BeneficiaryModal.vue?vue&type=script&lang=js"

import "./BeneficiaryModal.vue?vue&type=style&index=0&id=c05633e4&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c05633e4"]])

export default __exports__